import React from "react";
import "./MobileWarning.css";

const MobileWarning = () => {
  return (
    <div className="mobile-warning">
      <h2>🚧 Not Available on Mobile</h2>
      <p>This site is not optimized for mobile yet.</p>
      <p>Please visit BlockCode on a desktop or laptop for the best experience.</p>
    </div>
  );
};

export default MobileWarning;
